<div class="modal-header">
    <h4>{{ medarbejderName }}</h4>
    <button (click)="onDismiss()" type="button" data-bs-theme="dark" class="btn-close" aria-label="Close" tabindex="-1"></button>
</div>

<div class="modal-body">
    <div class="table__viewport">
        <table class="table table-hover table-striped table-sm table-frame__body" >
            <thead>
                <tr>
                    <th>Dato</th>
                    <th class="text-end">Timer</th>
                    <th>Sagsnavn</th>
                    <th>Kundenr</th>
                    <th>Kundenavn</th>
                </tr>
            </thead>

            <tbody>
                <tr *ngFor="let plantid of TidsforbrugPlantidViewList$ | async;">
                    <td>{{ plantid.year + ' ' + plantid.month }}</td>
                    <td class="text-end">{{ plantid.timer | time  }}</td>
                    <td>{{ plantid.sagsnavn }}</td>
                    <td>{{ plantid.kundenr }}</td>
                    <td>{{ plantid.kundenavn }}</td>
                </tr>
            </tbody>

            <tfoot>
                <tr>
                    <th>Total</th>
                    <th class="text-end">{{ totalHours | time }}</th>
                    <th></th>
                    <th></th>
                    <th></th>
                </tr>
            </tfoot>
        </table>
    </div>
</div>
